
/**
 * @typedef {import('./types.js').FontSource} FontSource
 */

/**
 * @interface
 */
export default class FontsSessionProvider {
    /**
     * @method getVariants
     * @param {String} family
     * @returns {Promise<FontSource[]>}
     */
}